<template>
  <div>
    <div style="width:100%;">
      <div style="width:70px;float:left;font-weight:bold;text-align:left;">
        <span>delivery&nbsp;</span>
      </div>
      <tool-tip-error v-if="!valid"
                      text="required"
                      type="deliveryDay"/>
      <div v-if="!review"
           class="custom-select"
           style="z-index:20;"
           @blur="open = false">
        <div class="selected"
             :class="{ open: open, 'invalid-indicator' : !valid }"
             style="z-index:20;"
             @click="open = !open">
          {{ selected == null ? 'select a day' : selected.formattedDeliveryDay }}
        </div>
        <div class="items"
             :class="{ selectHide: !open }">
          <div v-for="day of days"
               :key="day"
               :disabled="day.used"
               :class="day.used ? 'used-delivery-day' : ''"
               @click="getSelectedDay(day)">
            {{ day.formattedDeliveryDay }}
          </div>
        </div>
      </div>
      <span v-else class="review">{{ selectedDay.formattedDeliveryDay }}</span>
    </div>
    <div v-if="valid" style="display:inline-block;width:40%;float:left;font-size:10pt;text-align:left;">
      <span
          style="width:70px;color:red;font-style:italic;font-weight:bold;text-align:right;padding-left:1%;padding-right:1%;border:none;">
       *cutoff is {{ cutOffDayOfWeek }} {{ cutOffDate }} at {{ cutOffTime }}
      </span>
    </div>
    <div v-if="valid" style="display:inline-block;width:20%;float:right;">
      <div v-if="!review">
        <input v-model="noOrder"
               type="checkbox"
               :disabled="review"/>
        <span style="width:70px;font-style:italic;font-weight:bold;text-align:left;border:none">this is a 'no order'</span>
      </div>
      <div v-else-if="review && noOrder">
        <span style="width:70px;font-style:italic;font-weight:bold;text-align:right;">this is a 'no order'</span>
      </div>
    </div>
  </div>
</template>

<script>
import ToolTipError from '@/components/tooltip/TooltipError'

export default {
  name: 'DeliveryDays',
  props: ['dairyId', 'customerId', 'deliveryType', 'review', 'badDay'],
  emits: ['deliveryday', 'isvalid', 'apierror', 'apierrortext', 'noorder'],
  data: function () {
    return {
      days: [],
      selectedDay: {},
      valid: false,
      cutOffDate: '',
      cutOffTime: '',
      cutOffDayOfWeek: '',
      noOrder: false,
      selected: null,
      open: false,
    }
  },
  components: {
    ToolTipError,
  },
  methods: {
    getSelectedDay: function (day) {
      if (!day.used) {
        this.selected = day
        this.selectedDay = day
        this.open = false
      }
    },
  },
  watch: {
    selected: function (selection) {
      this.valid = _.includes(this.days, selection)
      if (this.valid) {
        this.cutOffDate = ('0' + selection.cutOffDate.monthValue).slice(-2) + '/' +
            ('0' + selection.cutOffDate.dayOfMonth).slice(-2) + '/' +
            selection.cutOffDate.year
        this.cutOffDayOfWeek = selection.cutOffDayOfWeek
        this.cutOffTime = ('0' + selection.cutOffTime.hour).slice(-2) + ':' +
            ('0' + selection.cutOffTime.minute).slice(-2)
        this.$emit('deliveryday', this.selectedDay)
      }
      this.$emit('isvalid', this.valid)
    },
    noOrder: function (noOrder) {
      this.noOrder = noOrder
      this.$emit('noorder', this.noOrder)
    },
    badDay: function (selection) {
      if (selection) {
        let result = this.days.find(f => f.deliveryDate == selection.deliveryDate)
        if (result) result.used = true
        this.selected = null
      }
    }
  },
  mounted() {
    this.$emit('isvalid', this.valid)
    this.noorder = false

    this.axios
        .get('schedule/deliveryDays', {
          params: {
            dairyId: this.dairyId,
            customerId: this.customerId,
            deliveryType: this.deliveryType,
          }
        })
        .then(response => {
          this.days = _.orderBy(response.data, ['deliveryDate'], ['asc'])
        })
        .catch(error => {
          this.$emit('apierror', true)
          this.$emit('apierrortext', error.response.statusText)
        })
  },
}
</script>

<style scoped>
.custom-select {
  position: relative;
  float: left;
  width: 210px;
  text-align: left;
  outline: none;
  height: 20px;
  line-height: 25px;
  font-size: 12pt;
  font-weight: bold;
}

.custom-select .selected {
  border: 1px solid #666666;
  padding-left: 0.5em;
  cursor: pointer;
  user-select: none;
}

.custom-select .selected.open {
  border: 1px solid black;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 12px;
  right: 1em;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: black transparent transparent transparent;
}

.custom-select .items {
  color: black;
  overflow: hidden;
  border: 1px solid black;
  position: absolute;
  background-color: white;
  left: 0;
  right: 0;
  z-index: 1;
}

.custom-select .items div {
  color: black;
  padding-left: 0.5em;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div:hover {
  background-color: lightgrey;
  font-weight: bold;
}

.selectHide {
  display: none;
}

.custom-select .items .used-delivery-day {
  text-decoration: line-through;
  font-weight: normal;
  color: gray;
}
</style>
